<script>
const removeSlotAssociation = (v, props) => {
	if (v && v.data) {
		v.data.slot = undefined;
	}

	v.componentOptions.propsData = {
		...v.componentOptions.propsData,
		...props,
	};
	
	return v;
};

const vueV = {
	functional: true,
	render: (_, {props}) => removeSlotAssociation(props.node, props.props),
};

export default vueV;
</script>
